module.exports = __webpack_public_path__ + "images/emoji/metro.826769ff474ecc24e743.png";